/**
 * SecureEmbed Energy Portal - StatCard Component
 */

import React from 'react';
import { ArrowUpRight, ArrowDownRight, LucideIcon } from 'lucide-react';
import InfoTooltip from './InfoTooltip';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  iconBg?: string;
  iconColor?: string;
  trend?: 'up' | 'down' | 'neutral';
  trendLabel?: string;
  tooltipId?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon: Icon,
  iconBg = 'bg-blue-100',
  iconColor = 'text-blue-600',
  trend,
  trendLabel,
  tooltipId,
}) => {
  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
      <div className="flex items-center justify-between">
        <div className={`w-12 h-12 ${iconBg} rounded-xl flex items-center justify-center`}>
          <Icon className={`w-6 h-6 ${iconColor}`} />
        </div>
        {trend === 'up' && <ArrowUpRight className="w-5 h-5 text-green-500" />}
        {trend === 'down' && <ArrowDownRight className="w-5 h-5 text-red-500" />}
      </div>
      <div className="mt-4">
        <h3 className="text-sm font-medium text-gray-500 flex items-center gap-1">
          {title}
          {tooltipId && <InfoTooltip tooltipId={tooltipId} />}
        </h3>
        <p className="text-3xl font-bold text-gray-900 mt-1">{value}</p>
        {trendLabel && (
          <p className={`text-xs mt-1 ${trend === 'up' ? 'text-green-600' : trend === 'down' ? 'text-red-600' : 'text-gray-500'}`}>
            {trendLabel}
          </p>
        )}
      </div>
    </div>
  );
};

export default StatCard;
